import React from "react";
import { object } from "prop-types";

import Carousel from "../../../atoms/carousel";
import CardImage from "../../../atoms/cardimage";
import RightArrow from "../../../atoms/icons/right-arrow";
import LeftArrow from "../../../atoms/icons/left-arrow";

import "./image-slider.m.css";

const sliderItemsView = (images) =>
  images.map((element, index) => (
    <CardImage
      key={index}
      imageType="image16x9"
      aspectRatio={[16, 9]}
      story={{
        "hero-image-s3-key": element["image-s3-key"],
        "hero-image-metadata": element["image-metadata"],
        "hero-image-caption": element.title || "",
      }}
    />
  ));

const ImageSlider = ({ element }) => {
  return (
    <div styleName="wrapper">
      <Carousel
        carouselName={`image-slider-${element.id}`}
        options={{
          type: "carousel",
          perView: 1,
          perTouch: 1,
        }}
        totalItems={element["story-elements"].length}
        leftArrow={<LeftArrow />}
        rightArrow={<RightArrow />}
      >
        {sliderItemsView(element["story-elements"])}
      </Carousel>
    </div>
  );
};

ImageSlider.propTypes = {
  element: object,
};

export default ImageSlider;
